export const gigyaLocaleMapping = {
    en: {
        countryName: 'United Kingdom',
        gigyaLocale: 'en',
        salesForceLocale: 'en-gb',
        countryCode: 'GB',
    },
    'en-us': {
        countryName: 'United States',
        gigyaLocale: 'en-us',
        salesForceLocale: 'en-us',
        countryCode: 'US',
    },
    'en-ca': {
        countryName: 'Canada (EN)',
        gigyaLocale: 'en-ca',
        salesForceLocale: 'en-ca',
        countryCode: 'CA',
    },
    'fr-ca': {
        countryName: 'Canada (FR)',
        gigyaLocale: 'fr-ca',
        salesForceLocale: 'fr-ca',
        countryCode: 'CA',
    },
    'es-mx': {
        countryName: 'Mexico',
        gigyaLocale: 'es-mx',
        salesForceLocale: 'es-mx',
        countryCode: 'MX',
    },
    'es-ar': {
        countryName: 'Argentina',
        gigyaLocale: 'es-ar',
        salesForceLocale: 'es-ar',
        countryCode: 'AR',
    },
    'es-pe': {
        countryName: 'Perù',
        gigyaLocale: 'es-pe',
        salesForceLocale: 'es-pe',
        countryCode: 'PE',
    },
    'es-co': {
        countryName: 'Colombia',
        gigyaLocale: 'es-co',
        salesForceLocale: 'es-co',
        countryCode: 'CO',
    },
    'pt-br': {
        countryName: 'Brasil',
        gigyaLocale: 'pt-br',
        salesForceLocale: 'pt-br',
        countryCode: 'BR',
    },
    'zh-cn': {
        countryName: 'China',
        gigyaLocale: 'zh-cn',
        salesForceLocale: 'zh-cn',
        countryCode: 'CN',
    },
    'en-hk': {
        countryName: 'Hong Kong',
        gigyaLocale: 'en-hk',
        salesForceLocale: 'en',
        countryCode: 'HK',
    },
    'es-cl': {
        countryName: 'Chile',
        gigyaLocale: 'es-cl',
        salesForceLocale: 'es-cl',
        countryCode: 'CL',
    },
    'en-za': {
        countryName: 'South Africa',
        gigyaLocale: 'en-za',
        salesForceLocale: 'en-za',
        countryCode: 'ZA',
    },
    pt: {
        countryName: 'Portugal',
        gigyaLocale: 'pt',
        salesForceLocale: 'pt-pt',
        countryCode: 'PT',
    },
    es: {
        countryName: 'Spain',
        gigyaLocale: 'es',
        salesForceLocale: 'es-es',
        countryCode: 'ES',
    },
    fr: {
        countryName: 'France',
        gigyaLocale: 'fr',
        salesForceLocale: 'fr-fr',
        countryCode: 'FR',
    },
    nl: {
        countryName: 'Netherlands',
        gigyaLocale: 'nl',
        salesForceLocale: 'nl-nl',
        countryCode: 'NL',
    },
    'fr-be': {
        countryName: 'Belgium(FR)',
        gigyaLocale: 'fr-be',
        salesForceLocale: 'fr-be',
        countryCode: 'BE',
    },
    'nl-inf': {
        countryName: 'Belgium(NL)',
        gigyaLocale: 'nl-inf',
        salesForceLocale: 'nl-be',
        countryCode: 'BE',
    },
    de: {
        countryName: 'Germany',
        gigyaLocale: 'de',
        salesForceLocale: 'de-de',
        countryCode: 'DE',
    },
    'de-inf': {
        countryName: 'Switzerland (DE)',
        gigyaLocale: 'de-inf',
        salesForceLocale: 'de-ch',
        countryCode: 'CH',
    },
    'fr-ch': {
        countryName: 'Switzerland (FR)',
        gigyaLocale: 'fr-ch',
        salesForceLocale: 'fr-ch',
        countryCode: 'CH',
    },
    it: {
        countryName: 'Italy',
        gigyaLocale: 'it',
        salesForceLocale: 'it-it',
        countryCode: 'IT',
    },
    hr: {
        countryName: 'Croatia',
        gigyaLocale: 'hr',
        salesForceLocale: 'hr-hr',
        countryCode: 'HR',
    },
    sr: {
        countryName: 'Serbia',
        gigyaLocale: 'sr',
        salesForceLocale: 'en',
        countryCode: 'RS',
    },
    sl: {
        countryName: 'Slovenia',
        gigyaLocale: 'sl',
        salesForceLocale: 'sl-si',
        countryCode: 'SI',
    },
    br: {
        countryName: 'Bulgaria',
        gigyaLocale: 'br',
        salesForceLocale: 'en',
        countryCode: 'BG',
    },
    el: {
        countryName: 'Greece',
        gigyaLocale: 'el',
        salesForceLocale: 'el-gr',
        countryCode: 'GR',
    },
    ro: {
        countryName: 'Romania',
        gigyaLocale: 'ro',
        salesForceLocale: 'ro-ro',
        countryCode: 'RO',
    },
    tr: {
        countryName: 'Turkey',
        gigyaLocale: 'tr',
        salesForceLocale: 'tr-tr',
        countryCode: 'TR',
    },
    cs: {
        countryName: 'Czech Republic',
        gigyaLocale: 'cs',
        salesForceLocale: 'cs-cz',
        countryCode: 'CZ',
    },
    sk: {
        countryName: 'Slovak Republic',
        gigyaLocale: 'sk',
        salesForceLocale: 'sk-sk',
        countryCode: 'SK',
    },
    hu: {
        countryName: 'Hungary',
        gigyaLocale: 'hu',
        salesForceLocale: 'hu-hu',
        countryCode: 'HU',
    },
    'de-at': {
        countryName: 'Austria',
        gigyaLocale: 'de-at',
        salesForceLocale: 'de-at',
        countryCode: 'AT',
    },
    uk: {
        countryName: 'Ukraine',
        gigyaLocale: 'uk',
        salesForceLocale: 'uk-ua',
        countryCode: 'UA',
    },
    ru: {
        countryName: 'Russia',
        gigyaLocale: 'ru',
        salesForceLocale: 'ru-ru',
        countryCode: 'RU',
    },
    sv: {
        countryName: 'Sweden',
        gigyaLocale: 'sv',
        salesForceLocale: 'sv-se',
        countryCode: 'SE',
    },
    fi: {
        countryName: 'Finland',
        gigyaLocale: 'fi',
        salesForceLocale: 'fi-fi',
        countryCode: 'FI',
    },
    no: {
        countryName: 'Norway',
        gigyaLocale: 'no',
        salesForceLocale: 'nb-no',
        countryCode: 'NO',
    },
    da: {
        countryName: 'Denmark',
        gigyaLocale: 'da',
        salesForceLocale: 'da-dk',
        countryCode: 'DK',
    },
    pl: {
        countryName: 'Poland',
        gigyaLocale: 'pl',
        salesForceLocale: 'pl-pl',
        countryCode: 'PL',
    },
    'et-ee': {
        countryName: 'Estonia',
        gigyaLocale: 'et-ee',
        salesForceLocale: 'et-ee',
        countryCode: 'EE',
    },
    'lt-lt': {
        countryName: 'Lithuania',
        gigyaLocale: 'lt-lt',
        salesForceLocale: 'lt-lt',
        countryCode: 'LT',
    },
    'lv-lv': {
        countryName: 'Latvia',
        gigyaLocale: 'lv-lv',
        salesForceLocale: 'lv-lv',
        countryCode: 'LV',
    },
    'en-ae': {
        countryName: 'United Arab Emirates',
        gigyaLocale: 'en-ae',
        salesForceLocale: 'en',
        countryCode: 'AE',
    },
    'ar-ae': {
        countryName: 'United Arab Emirates',
        gigyaLocale: 'ar-ae',
        salesForceLocale: 'ar-ae',
        countryCode: 'AE',
    },
    'en-sg': {
        countryName: 'SIngapore',
        gigyaLocale: 'en-sg',
        salesForceLocale: 'en-sg',
        countryCode: 'SG',
    },
    'en-my': {
        countryName: 'Malaysia',
        gigyaLocale: 'en-my',
        salesForceLocale: 'en-my',
        countryCode: 'MY',
    },
    'en-au': {
        countryName: 'Australia',
        gigyaLocale: 'en-au',
        salesForceLocale: 'en-au',
        countryCode: 'AU',
    },
    'en-nz': {
        countryName: 'New Zealand',
        gigyaLocale: 'en-nz',
        salesForceLocale: 'en-nz',
        countryCode: 'NZ',
    },
    ja: {
        countryName: 'Japan',
        gigyaLocale: 'ja',
        salesForceLocale: 'ja-jp',
        countryCode: 'JP',
    },
    ko: {
        countryName: 'South Korea',
        gigyaLocale: 'ko',
        salesForceLocale: 'ko-kr',
        countryCode: 'KR',
    },
    'en-kh': {
        countryName: 'Cambodia',
        gigyaLocale: 'en-kh',
        salesForceLocale: 'en',
        countryCode: 'KH',
    },
    'en-bd': {
        countryName: 'Bangladesh',
        gigyaLocale: 'en-bd',
        salesForceLocale: 'en',
        countryCode: 'BD',
    },
    th: {
        countryName: 'Thailand',
        gigyaLocale: 'th',
        salesForceLocale: 'th-th',
        countryCode: 'TH',
    },
    'en-th': {
        countryName: 'Thailand',
        gigyaLocale: 'en-th',
        salesForceLocale: 'en',
        countryCode: 'TH',
    },
    'ar-eg': {
        countryName: 'Egypt',
        gigyaLocale: 'ar-eg',
        salesForceLocale: 'ar-eg',
        countryCode: 'EG',
    },
    'en-eg': {
        countryName: 'Egypt',
        gigyaLocale: 'en-eg',
        salesForceLocale: 'en',
        countryCode: 'EG',
    },
    'en-in': {
        countryName: 'India',
        gigyaLocale: 'en-in',
        salesForceLocale: 'en-in',
        countryCode: 'IN',
    },
    'en-ir': {
        countryName: 'Iran',
        gigyaLocale: 'en-ir',
        salesForceLocale: 'en',
        countryCode: 'IR',
    },
    fa: {
        countryName: 'Iran',
        gigyaLocale: 'fa',
        salesForceLocale: 'fa-ir',
        countryCode: 'IR',
    },
    'en-il': {
        countryName: 'Israel',
        gigyaLocale: 'en-il',
        salesForceLocale: 'en',
        countryCode: 'IL',
    },
    'en-sa': {
        countryName: 'Saudi Arabia',
        gigyaLocale: 'en-sa',
        salesForceLocale: 'en',
        countryCode: 'SA',
    },
    'ar-sa': {
        countryName: 'Saudi Arabia',
        gigyaLocale: 'ar-sa',
        salesForceLocale: 'ar-sa',
        countryCode: 'SA',
    },
    'en-ie': {
        countryName: 'Ireland',
        gigyaLocale: 'en-ie',
        salesForceLocale: 'en-ie',
        countryCode: 'IE',
    },
    'en-id': {
        countryName: 'Indonesia',
        gigyaLocale: 'en-id',
        salesForceLocale: 'en',
        countryCode: 'ID',
    },
    'en-ph': {
        countryName: 'Philippines',
        gigyaLocale: 'en-ph',
        salesForceLocale: 'en-ph',
        countryCode: 'PH',
    },
    'zh-tw': {
        countryName: 'Taiwan',
        gigyaLocale: 'zh-tw',
        salesForceLocale: 'zh-tw',
        countryCode: 'TW',
    },
    vi: {
        countryName: 'Vietnam',
        gigyaLocale: 'vi',
        salesForceLocale: 'vi-vn',
        countryCode: 'VN',
    },
    'ru-by': {
        countryName: 'Belarus',
        gigyaLocale: 'ru-by',
        salesForceLocale: 'be-by',
        countryCode: 'BY',
    },
    'ru-kz': {
        countryName: 'Kazakhstan',
        gigyaLocale: 'ru-kz',
        salesForceLocale: 'kk-kz',
        countryCode: 'KZ',
    },
}

export const salesForceToGigyaLocaleMapping = () =>
    Object.fromEntries(
        Object.values(gigyaLocaleMapping).map(({salesForceLocale, gigyaLocale}) => [
            salesForceLocale,
            gigyaLocale,
        ]),
    )
